import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Menudata from '../../data/menu/index';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Icon from '../../components/common/icon';
import { faLongArrowAltLeft, faRightToBracket } from '@fortawesome/free-solid-svg-icons';
import './menu.scss';

function Menu({ onLoginClick }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const [active, setActive] = useState();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const activeLink = (link) => {
    toggle();
    setActive(link);
    const header = document.querySelector('.header-sticky');
    return header ? header.offsetHeight + 10 : 80;
  };

  return (
    <nav className="navbar navbar-wrapper menu-wrapper">
      <div className="sidebar-toggle">
        <button className="menu-btn navbar-toggler" type="button" id="navbar-menu-btn" onClick={toggle}>
          <span className="btn-block"></span><p className="title">Menu</p>
        </button>
      </div>

      <button type="button" className="login-pill" aria-label="Login" onClick={onLoginClick}>
        <Icon icon={faRightToBracket} />
        <span>Login</span>
      </button>

      <div className={isOpen ? 'open' : ''} id="sidebar">
        <div className="sidebar-overlay"></div>
        <div className="sidebar-wrapper">
          <div className="slidebar-title-wrapper">
            <div className="slidebar-title">
              <div id="slidebar-close-btn" onClick={toggle}>
                <span><Icon icon={faLongArrowAltLeft} /></span>
              </div>
            </div>
          </div>
          <div className="navbar-link-wrapper">
            <ul className="navbar-nav navbar-menu-frist" id="menu-navbar">
              {Menudata.map((file, index) => (
                <li key={index} className={`nav-item-box ${active === file.href ? 'is-active' : ''}`}>
                  {isHomePage ? (
                    <AnchorLink offset={() => activeLink(file.href)} href={file.href}>
                      <span>{file.title}</span>
                    </AnchorLink>
                  ) : (
                    <Link to={`/${file.href}`} onClick={toggle}>
                      <span>{file.title}</span>
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Menu;
